import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import ModalDialog from 'common/components/modal/modal_dialog';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { TextAreaField, MultipleFileSelectorField } from 'common/components/form_fields';
import AnimatedButton from 'common/components/animated_button';

const PROOFS_FAQ_URL = '/help/working-in-projects/what-should-i-upload-during-proof-step-wrap-/';
const FINAL_FILES_FAQ_URL = '/help/working-in-projects/what-are-the-file-formats-required-by-clients/';
const LOGO_PROOFS_SHEET_URL = 'https://s3.amazonaws.com/crowdspring3-assets/marketing/help/cs-logo-proof-sheet-template-Aug2018.pdf';
const STATIONERY_PROOFS_SHEET_URL = 'https://s3.amazonaws.com/crowdspring3-assets/marketing/help/Stationery-Design-Sheet-Template.pdf';

const COMMENT_CHAR_LIMIT = 255;

let Form = ({
  error, handleSubmit, submitting, submitFailed, onClose, acceptedFormats='all', itemsToUpload,
  type, project
}) => {

  const itemsToInclude = (itemsToUpload || '').split('\n').filter(i => i);

  let proofsSheetUrl;
  if ([23, 24, 25, 79, 80, 81].includes(project.sub_category)) {
    proofsSheetUrl = LOGO_PROOFS_SHEET_URL;
  } else if ([26, 93].includes(project.sub_category)) {
    proofsSheetUrl = STATIONERY_PROOFS_SHEET_URL;
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="columns small-16 medium-5">
          <section>
            <h3>Requirements</h3>
            <ul>
              <li>Accepted formats: { acceptedFormats }</li>
              <li>Maximum file size 100 mb</li>
            </ul>
          </section>
          <section>
            <h3>Tips</h3>
            { type === "proofs"?
            <div>
              <p>
                Do not provide final hi-rez files. Use a proof sheet and upload your files
                in PDF, JPG or PNG format. Read our <Link target="_blank" to={PROOFS_FAQ_URL}>
                FAQ on proofs</Link>.
              </p>
              { proofsSheetUrl &&
              <p>
                Complete your project faster and get paid faster. Use our <Link to={proofsSheetUrl}
                target="_blank"> proof sheet template</Link>.
              </p> }
            </div> : <p>
              Please provide all required final files. Include an original, editable file, and RGB
              and CMYK format files, when appropriate. Also include a web preview file (PNG, JPEG,
              PDF). Read our <Link target="_blank" to={FINAL_FILES_FAQ_URL}>FAQ on final files
              </Link>.
            </p> }
          </section>
          { itemsToInclude.length > 0 &&
          <section>
            <h3>What to include:</h3>
            <ul>
              { itemsToInclude.map((item, i) => <li key={i}>{ item }</li>) }
            </ul>
          </section> }
        </div>
        <div className="columns small-16 medium-11">
          <fieldset>
            <Field name="files" component={MultipleFileSelectorField}/>

            <Field name="comment" description="Optional comment:" component={TextAreaField}
              maxCharCount={COMMENT_CHAR_LIMIT} rows={4} />
          </fieldset>
        </div>
      </div>

      <div className="modal-actions">
        <AnimatedButton processing={submitting} type="submit" label="Done"
          processingLabel="Uploading..." errorMsg={error || submitFailed}
          baseBtnClass="btn btn-tertiary btn-block" successMsg="Done!"/>

        <button className="btn btn-text btn-block" onClick={onClose}>
          Cancel
        </button>
      </div>
    </form>
  );
}

const validate = values => {
  const errors = {};

  if (!values.files || values.files.length == 0) {
    errors.files = 'Please select at least one file';
  }

  if (values.comment && values.comment.length > COMMENT_CHAR_LIMIT) {
    errors.comment = `The comment must have a maximum of ${COMMENT_CHAR_LIMIT} characters`;
  }

  return errors;
}

Form = reduxForm({
  form: "UploadBundlesModal",
  validate
})(Form);


export default class UploadBundlesModal extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(formData) {
    /* bundle upload is done in 2 steps:
       1 - create empty bundle
       2 - upload files to bundle */

    const {
      wrapup, createBundleRequest, uploadFilesRequest, fetchWrapupsIfNeeded, type,
      fetchMessagesIfNeeded, onClose
    } = this.props;
    const { award, project_id, proof_message_stream, final_message_stream } = wrapup;

    return createBundleRequest(award.id)
      .then(({ data }) => uploadFilesRequest(award.id, { ...formData, 'bundle_id': data }))
      .then(() => {
        /* reload wrapups and messages and close modal */
        fetchWrapupsIfNeeded(project_id, true);
        fetchMessagesIfNeeded({
          streamId: type === "proofs"? proof_message_stream : final_message_stream,
          wrapupStep: type === "proofs"? "approve_proofs" : "approve_files",
          force: true,
          wrapup
        });
        onClose();
      })
      .catch((res) => {
        /* global error */
        throw new SubmissionError({ _error: 'Failed to upload files. Please try again.' });
      });
  }

  render() {
    const { onClose, type } = this.props;

    return (
      <ModalDialog
        modalOpen={true}
        dialogClasses="upload-bundles-modal"
        closeAction={onClose}
        modalHeader={`Add ${type}`}
        contentClasses="wide"
      >

        <Form {...this.props} onSubmit={this.handleSubmit} />
      </ModalDialog>
    );
  }
}

UploadBundlesModal.propTypes = {
  wrapup: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  createBundleRequest: PropTypes.func.isRequired,
  uploadFilesRequest: PropTypes.func.isRequired,
  fetchWrapupsIfNeeded: PropTypes.func.isRequired,
  fetchMessagesIfNeeded: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  acceptedFormats: PropTypes.string,
  itemsToUpload: PropTypes.string
};



// WEBPACK FOOTER //
// ./project/components/wrapup/upload_bundles_modal.jsx